__turbopack_context__.v({
  "className": "microgramma_e736cfa8-module__pfR3Ha__className",
});
